(function () {
  const ROOT_SELECTOR = '[data-bz-cart-upsell-root]';
  const WRAPPER_SELECTOR = '.bz-cart__upsell';

  function getConfig() {
    const el = document.getElementById('bz-shipping-config');
    if (!el) return null;

    try {
      return JSON.parse(el.textContent);
    } catch {
      return null;
    }
  }

  function updateVisibility(subtotal) {
  const drawer = document.querySelector('cart-drawer-component');
  if (!drawer) return;

  const wrapper = drawer.querySelector('.bz-cart__upsell');
  if (!wrapper) return;

  const config = getConfig();
  if (!config?.thresholdCents) return;

  const threshold = config.thresholdCents;
  const remaining = Math.max(threshold - subtotal, 0);

  if (remaining <= 0) {
    wrapper.style.display = 'none';
  } else {
    wrapper.style.display = '';
  }
}

  function bindEvents() {
    // 🔥 MAIN DRIVER (shipping system)
    document.addEventListener('bz:shipping:updated', (e) => {
      const subtotal = e.detail?.subtotal;
      if (typeof subtotal !== 'number') return;

      updateVisibility(subtotal);
    });

    // 🔥 INITIAL LOAD (important)
    window.addEventListener('load', async () => {
      try {
        const res = await fetch('/cart.js', {
          credentials: 'same-origin',
          cache: 'no-store',
        });

        if (!res.ok) return;

        const cart = await res.json();
        updateVisibility(cart.items_subtotal_price);
      } catch {
        // fail silently
      }
    });
  }

  bindEvents();
})();